import * as React from "react";
import * as classnames from "classnames";
import * as uuidV4 from "uuid/v4";
import Label from "../internal/Label";
var InputGroup = function (_a) {
    var children = _a.children, _b = _a.className, className = _b === void 0 ? "" : _b, _c = _a.id, id = _c === void 0 ? "" : _c, _d = _a.label, label = _d === void 0 ? "" : _d, _e = _a.stretched, stretched = _e === void 0 ? false : _e;
    var inputID = id || uuidV4();
    var classNames = classnames("wds-input-group", { "wds-input-group--stretched": stretched }, className);
    return (React.createElement(React.Fragment, null,
        label && React.createElement(Label, { htmlFor: inputID }, label),
        React.createElement("div", { id: inputID, className: classNames }, children)));
};
export default InputGroup;
//# sourceMappingURL=InputGroup.js.map


//////////////////
// WEBPACK FOOTER
// ../node_modules/@sm/smapply-ui/dist/es/components/InputGroup/InputGroup.js
// module id = 1782
// module chunks = 17